export default __webpack_public_path__ + "static/background-07befa1ebb7cfa6161f4baf80ab78c81.png";